import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Stack from 'components/Stack';
import SimpleModal from 'components/SimpleModal';
import { useDisconnectMyCalendar } from './hooks/useDisconnectMyCalendar';
function DisconnectConfirmationModal(_ref) {
  var provider = _ref.provider,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useDisconnectMyCalen = useDisconnectMyCalendar(),
    disconnectMyCalendar = _useDisconnectMyCalen.disconnectMyCalendar,
    isLoading = _useDisconnectMyCalen.isLoading;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    width: "wide",
    title: t(provider === 'google' ? 'modal_disconnect_calendar_google_title' : 'modal_disconnect_calendar_microsoft_title'),
    body: /*#__PURE__*/React.createElement(Stack, {
      spacing: "xs"
    }, /*#__PURE__*/React.createElement("p", null, t('modal_disconnect_calendar_message_1')), /*#__PURE__*/React.createElement("p", null, t('modal_disconnect_calendar_message_2'))),
    buttons: [{
      label: t('actions_cancel'),
      onClick: onClose,
      isDisabled: isLoading
    }, {
      isLoading: isLoading,
      label: t('actions_disconnect'),
      onClick: function () {
        var _onClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return disconnectMyCalendar(provider);
              case 2:
                onClose();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function onClick() {
          return _onClick.apply(this, arguments);
        }
        return onClick;
      }(),
      variant: 'primary'
    }],
    onClose: onClose
  });
}
export default DisconnectConfirmationModal;